export default "sfu"